module.exports = __webpack_public_path__ + "static/logo_flutter-67642a0b80f3d50277c44cde8f450e50.png";